module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ftNFz"))).then(() => parcelRequire('iDabs'));